import { onScopeDispose, ref } from "vue"
import { KVKRepository } from "@/repositories/external/kvk-repository"

export function useKVKSearch() {
  const results = ref<any[]>([])
  const isSearching = ref(false)
  const error = ref("")
  let revision = 0
  let timeout: ReturnType<typeof setTimeout> | undefined

  function cancel() {
    revision++
    clearTimeout(timeout)
    isSearching.value = false
    results.value = []
    error.value = ""
  }

  function schedule(query: string) {
    cancel()
    const searchTerm = query.trim()
    if (!searchTerm) return
    const requestRevision = revision
    isSearching.value = true
    timeout = setTimeout(() => void search(searchTerm, requestRevision), 200)
  }

  async function search(searchTerm: string, requestRevision: number) {
    try {
      const response = await new KVKRepository().searchByName(searchTerm)
      if (requestRevision !== revision) return
      results.value = (response.resultaten ?? [])
        .filter((item: any) => item.adres)
        .map((item: any, index: number) => ({ ...item, id: index }))
    } catch {
      if (requestRevision !== revision) return
      error.value =
        "Zoeken in het handelsregister is mislukt. Bestaande bedrijven kun je wel kiezen."
    } finally {
      // A previous request must not stop the spinner for a newer search.
      if (requestRevision === revision) isSearching.value = false
    }
  }

  onScopeDispose(cancel)
  return { results, isSearching, error, schedule, cancel }
}
